import format from '@/functions/format';
import ComplexMultiplier from '@/interfaces/complexMultiplier.interface';

export interface OriginalFilter {
    formId: string;
    hasValue?: boolean;
    id: string;
    infinityIndicator: boolean;
    max?: number;
    min?: number;
    multiplier?: number;
    multiplierComplex?: ComplexMultiplier[] | null;
    name: string;
    options?: {
        id: string | number;
        name: string;
        shortName: string;
        [key: string]: any;
    }[];
    postFix?: string;
    preFix?: string;
    shortName: string;
    taglabel: string;
    value?: string | null;
    valueMap?:
        | {
              100: string;
              200: string;
              300: string;
              400: string;
              500: string;
              600: string;
              700: string;
          }[]
        | null;
    [key: string]: any;
}

export interface Original {
    sectionName: string;
    screenReader: string;
    filters: {
        filter: OriginalFilter;
        type:
            | 'CheckboxFilter'
            | 'RangeFilter'
            | 'ValueMapRangeFilter'
            | 'ZipcodeFilter';
    }[];
}

export interface FilterOption {
    name: string;
    shortValue: string;
    value: string | number;
}

export interface SearchFilter {
    ariaLabel: string;
    append?: string;
    complexInterval?: number[];
    key: string;
    infinityIndicator: boolean;
    interval?: number;
    max?: number;
    min?: number;
    name: string;
    options?: FilterOption[];
    prepend?: string;
    shortName: string;
    tagLabel: string;
    type: 'tags' | 'range' | 'input' | 'valueMapRange';
    valueMap: {
        [key: number]: string;
    };
}

export interface FilterGroup {
    filters: SearchFilter[];
    name: string;
}

export default class SearchFilters {
    groups: FilterGroup[] = [];

    /**
     * @constructor
     * @param {Original} data
     */
    constructor(data: Original[]) {
        data.forEach((item: Original) => {
            let group = <FilterGroup>{
                ariaLabel: item.screenReader,
                filters: <SearchFilter[]>[],
                name: item.sectionName,
            };

            item.filters.forEach((subItem: any) => {
                let filter = <SearchFilter>{
                    key: subItem.filter.id,
                    name: subItem.filter.name,
                    shortName: subItem.filter.shortName,
                    tagLabel: subItem.filter.taglabel,
                };

                if (subItem.type === 'CheckboxFilter') {
                    let options = <FilterOption[]>[];
                    subItem.filter.options.forEach((optionItem: any) => {
                        options.push(<FilterOption>{
                            name: optionItem.name,
                            value: optionItem.id,
                        });
                    });

                    filter.options = options;
                    filter.type = 'tags';
                } else if (subItem.type === 'RangeFilter') {
                    filter.append =
                        subItem.filter.postFix !== undefined
                            ? subItem.filter.postFix
                            : '';
                    filter.infinityIndicator = subItem.filter.infinityIndicator;
                    filter.interval = subItem.filter.multiplier;
                    filter.max = subItem.filter.max;
                    filter.min = subItem.filter.min;
                    filter.prepend =
                        subItem.filter.preFix !== undefined
                            ? subItem.filter.preFix
                            : '';
                    filter.type = 'range';

                    if (subItem.filter.multiplierComplex) {
                        filter.complexInterval = format.complexInterval(
                            subItem.filter.multiplierComplex,
                            subItem.filter.min,
                            subItem.filter.max,
                        );
                    }
                } else if (subItem.type === 'ZipcodeFilter') {
                    filter.type = 'input';
                } else if (subItem.type === 'ValueMapRangeFilter') {
                    filter.interval = subItem.filter.multiplier;
                    filter.max = subItem.filter.max;
                    filter.min = subItem.filter.min;
                    filter.type = 'valueMapRange';
                    filter.valueMap = subItem.filter.valueMap;
                }

                group.filters.push(<SearchFilter>filter);
            });

            this.groups.push(group);
        });
    }
}
